import { $Q, $Qll } from "../utils/querySelector"

export const deleteButtonStyles = () => {
  const klaviyoContainer = $Qll(".klaviyo-product-container");

  if (klaviyoContainer != null) {
    klaviyoContainer.forEach(container => {
      const subContainer = $Q(".klaviyo-button-container", container);

      console.log(container)

      container.removeAttribute("style");
      if (subContainer) subContainer.removeAttribute("style");
    });
  }
}